import { render, staticRenderFns } from "./project_nation.vue?vue&type=template&id=4b64aee2&scoped=true"
import script from "./project_nation.vue?vue&type=script&lang=js"
export * from "./project_nation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b64aee2",
  null
  
)

export default component.exports